import React from 'react';
import Loadable from 'react-loadable'

// function Loading() {
//     return <div></div>;
// }

function Loading() {
    return <div className="loading">
        <div className="spinner-grow text-muted"></div>
        <div className="spinner-grow text-primary"></div>
        <div className="spinner-grow text-success"></div>
    </div>;
}

// Dashboard
const Dashboard = Loadable({
    loader: () => import('./Views/Dashboard/Dashboard.js'),
    loading: Loading,
});
// Driver
const Driver = Loadable({
    loader: () => import('./Views/Represesntive/viewDriver/viewDriver'),
    loading: Loading,
});

const AddDriver = Loadable({
    loader: () => import('./Views/Represesntive/AddDriver/adddriver.js'),
    loading: Loading,
});

const DriverDetails = Loadable({
    loader: () => import('./Views/Represesntive/driverDetails/driverDetails'),
    loading: Loading,
});
const EditDriver = Loadable({
    loader: () => import('./Views/Represesntive/EditDriver/editdriver.js'),
    loading: Loading,
});


//client
const ViewClient = Loadable({
    loader: () => import('./Views/Client/ViewClient/viewclient.js'),
    loading: Loading,
});

const AddClient = Loadable({
    loader: () => import('./Views/Client/AddClient/addclient.js'),
    loading: Loading,
});

const EditClient = Loadable({
    loader: () => import('./Views/Client/EditClient/editclient.js'),
    loading: Loading,
});

const clientDetails = Loadable({
    loader: () => import('./Views/Client/ClientDetails/ClientDetails'),
    loading: Loading,
});


// Admins
const SubAdmins = Loadable({
    loader: () => import('./Views/Subadmins/SubadminsView/SubadminsView'),
    loading: Loading
});

const AddAdmin = Loadable({
    loader: () => import('./Views/Subadmins/AddAdmin/AddAdmin'),
    loading: Loading
});

const EditAdmin = Loadable({
    loader: () => import('./Views/Subadmins/EditSubAdmin/EditSubAdmin'),
    loading: Loading
});

const adminDetails = Loadable({
    loader: () => import('./Views/Subadmins/adminDetails/ViewAdmin'),
    loading: Loading
});



// Rules
// const ALLRules = Loadable({
//     loader: () => import('./Views/ViewRules/rule'),
//     loading: Loading
// });

const Rules = Loadable({
    loader: () => import('./Views/Rules/ManageRules/Rules'),
    loading: Loading
});

// App Settings
const AboutUs = Loadable({
    loader: () => import('./Views/Appsettings/AbouUs/AbouUs'),
    loading: Loading
});

const RulesConditions = Loadable({
    loader: () => import('./Views/Appsettings/RulesConditions/RulesConditions'),
    loading: Loading
});

const ViewBanners = Loadable({
    loader: () => import('./Views/Appsettings/Banners/ViewBanners/ViewBanners'),
    loading: Loading
});

const EditBanner = Loadable({
    loader: () => import('./Views/Appsettings/Banners/EditBanner/EditBanner'),
    loading: Loading
});

const AddBanner = Loadable({
    loader: () => import('./Views/Appsettings/Banners/AddBanner/AddBanner'),
    loading: Loading
});

const Privacy = Loadable({
    loader: () => import('./Views/Appsettings/Privacy/Privacy'),
    loading: Loading
});

const DileveryCost = Loadable({
    loader: () => import('./Views/Appsettings/DileveryCost/DileveryCost'),
    loading: Loading
});

const EditInformation = Loadable({
    loader: () => import('./Views/Appsettings/EditLogo/EditLogo'),
    loading: Loading
});
const ViewReasons = Loadable({
    loader: () => import('./Views/Appsettings/Reasons/ViewReasons/viewreasons.js'),
    loading: Loading
});

const AddReasons = Loadable({
    loader: () => import('./Views/Appsettings/Reasons/AddReason/addreason.js'),
    loading: Loading
});
const Editreason = Loadable({
    loader: () => import('./Views/Appsettings/Reasons/EditReason/EditReason'),
    loading: Loading
});


//Orders
const ViewOrders = Loadable({
    loader: () => import('./Views/Orders/ViewOrders/vieworders.js'),
    loading: Loading
});

const AddOrders = Loadable({
    loader: () => import('./Views/Orders/AddOrder/addorder.js'),
    loading: Loading
});

const EditOrders = Loadable({
    loader: () => import('./Views/Orders/EditOrder/editorder.js'),
    loading: Loading
});

const OrdersDetails = Loadable({
    loader: () => import('./Views/Orders/OrderDetails/orderdetails.js'),
    loading: Loading
});

const PricingOrder = Loadable({
    loader: () => import('./Views/Orders/PricingOrder/pricingOrder.js'),
    loading: Loading
});

const ViewNotPricing = Loadable({
    loader: () => import('./Views/Orders/NotPricingOrder/NotPricingOrderView/NotPricingOrder'),
    loading: Loading
});

// Products

const ViewProducts = Loadable({
    loader: () => import('./Views/Product/ViewProducts/ViewProducts'),
    loading: Loading
});

const EditProduct = Loadable({
    loader: () => import('./Views/Product/EditProduct/EditProduct'),
    loading: Loading
});

const AddProduct = Loadable({
    loader: () => import('./Views/Product/AddProduct/AddProduct'),
    loading: Loading
});

// Reports
const Reports = Loadable({
    loader: () => import('./Views/Reports/Reports.js'),
    loading: Loading
});

const CreateReport = Loadable({
    loader: () => import('./Views/Reports/CreateReport.js'),
    loading: Loading
});

// Certifications

const ViewCertifications = Loadable({
    loader: () => import('./Views/Certifications/ViewCertifications/ViewCertifications'),
    loading: Loading
});

const EditCertificate = Loadable({
    loader: () => import('./Views/Certifications/EditCertificate/EditCertificate'),
    loading: Loading
});

const AddCertificate = Loadable({
    loader: () => import('./Views/Certifications/AddCertificate/AddCertificate'),
    loading: Loading
});

// Shop
const Shop = Loadable({
    loader: () => import('./Views/Shop/Shop'),
    loading: Loading
});

// Services
const Services = Loadable({
    loader: () => import('./Views/Services/Services'),
    loading: Loading
});
// Services
const UserRules = Loadable({
    loader: () => import('./Views/Rules/RulesView/RulesView'),
    loading: Loading
});
// Levels
const ViewLevels = Loadable({
    loader: () => import('./Views/Levels/ViewLevels/ViewLevels'),
    loading: Loading
});
const AddLevel = Loadable({
    loader: () => import('./Views/Levels/AddLevel/AddLevel'),
    loading: Loading
});
const EditLevel = Loadable({
    loader: () => import('./Views/Levels/EditLevel/EditLevel'),
    loading: Loading
});

// Promo
const PromoView = Loadable({
    loader: () => import('./Views/PromoCode/ViewPromo/ViewPromo'),
    loading: Loading
});
const AddPromo = Loadable({
    loader: () => import('./Views/PromoCode/AddPromo/AddPromo'),
    loading: Loading
});
const EditPromo = Loadable({
    loader: () => import('./Views/PromoCode/EditPromo/EditPromo'),
    loading: Loading
});

// SocialLinks
const SocialLinks = Loadable({
    loader: () => import('./Views/Appsettings/SocialLinks/SocialLinks'),
    loading: Loading
});


//materials
const ViewMaterials = Loadable({
    loader: () => import('./Views/Materials/ViewMaterial/viewmaterial.js'),
    loading: Loading
});
const AddMaterials = Loadable({
    loader: () => import('./Views/Materials/AddMaterial/addmaterial.js'),
    loading: Loading
});

const ViewNotPricedMaterials = Loadable({
    loader: () => import('./Views/Materials/ViewMaterialsNotPriced/viewnotpriced.js'),
    loading: Loading
});

const Editmaterialprice = Loadable({
    loader: () => import('./Views/Materials/Editmaterial/editmaterialprice.js'),
    loading: Loading
});

//Notification
const ViewNotification = Loadable({
    loader: () => import('./Views/Notification/ViewNotification/viewnotification.js'),
    loading: Loading
});

const AddNotification = Loadable({
    loader: () => import('./Views/Notification/AddNotification/addnotification.js'),
    loading: Loading
});
const HandedandRecieved = Loadable({
    loader: () => import('./Views/Appsettings/HandedandRecived/handed.js'),
    loading: Loading
});


const routes = [

    // Dashboard
    
    { path: '/Maktapti/HandedandRecieved', exact: true, name: 'HandedandRecieved', component: HandedandRecieved },
    { path: '/Maktapti/Dashboard', exact: true, name: 'Dashboard', component: Dashboard },
    // Driver
    { path: '/Maktapti/Driver', exact: true, name: 'Driver', component: Driver },
    { path: '/Maktapti/AddDriver', exact: true, name: 'AddDriver', component: AddDriver },
    { path: '/Maktapti/Drivers/DriverDetails', exact: true, name: 'DriverDetails', component: DriverDetails },

    { path: '/Maktapti/EditDriver', exact: true, name: 'EditDriver', component: EditDriver },

    //client
    { path: '/Maktapti/ViewClient', exact: true, name: 'ViewClient', component: ViewClient },
    { path: '/Maktapti/AddClient', exact: true, name: 'AddClient', component: AddClient },
    { path: '/Maktapti/EditClient', exact: true, name: 'EditClient', component: EditClient },
    { path: '/Maktapti/Clients/clientDetails', exact: true, name: 'clientDetails', component: clientDetails },

    // Rules
    { path: '/Maktapti/ManageRules', exact: true, name: 'Rules', component: Rules },
    // { path: '/ALLRules', exact: true, name: 'RulesView', component: ALLRules },
    {path:"/Maktapti/UserRules", name: 'UserRules', component: UserRules },


    // SubAdmins
    { path: '/Maktapti/SubAdmins', exact: true, name: 'SubAdmins', component: SubAdmins },
    { path: '/Maktapti/Admins/AddAdmin', exact: true, name: 'AddAdmin', component: AddAdmin },
    { path: '/Maktapti/Admins/EditAdmin', exact: true, name: 'EditAdmin', component: EditAdmin },
    { path: '/Maktapti/Admins/adminDetails', exact: true, name: 'adminDetails', component: adminDetails },

    // AppSettings
    { path: '/Maktapti/AboutApp', exact: true, name: 'AboutUs', component: AboutUs },
    { path: '/Maktapti/RulesConditions', exact: true, name: 'RulesConditions', component: RulesConditions },
    { path: '/Maktapti/ViewBanners', exact: true, name: 'ViewBanners', component: ViewBanners },
    { path: '/Maktapti/Banners/EditBanner', exact: true, name: 'EditBanner', component: EditBanner },
    { path: '/Maktapti/Banners/AddBanner', exact: true, name: 'AddBanner', component: AddBanner },
    { path: '/Maktapti/Privacy', exact: true, name: 'Privacy', component: Privacy },
    { path: '/Maktapti/DileveryCost', exact: true, name: 'DileveryCost', component: DileveryCost },
    { path: '/Maktapti/EditInformation', exact: true, name: 'EditInformation', component: EditInformation },
    { path: '/Maktapti/ViewReasons', exact: true, name: 'ViewReasons', component: ViewReasons },
    { path: '/Maktapti/AddReasons', exact: true, name: 'AddReasons', component: AddReasons },
    { path: '/Maktapti/Editreason', exact: true, name: 'Editreason', component: Editreason },
    

    //Orders
    { path: '/Maktapti/ViewNotPricing', exact: true, name: 'ViewOrders', component: ViewOrders },
    { path: '/Maktapti/AddOrders', exact: true, name: 'AddOrders', component: AddOrders },
    { path: '/Maktapti/EditOrders', exact: true, name: 'EditOrders', component: EditOrders },
    { path: '/Maktapti/OrdersDetails', exact: true, name: 'OrdersDetails', component: OrdersDetails },
    { path: '/Maktapti/PricingOrder', exact: true, name: 'PricingOrder', component: PricingOrder },
    { path: '/Maktapti/ViewPricing', exact: true, name: 'ViewNotPricing', component: ViewNotPricing },
    // { path: '/PricingOrder', exact: true, name: 'PricingOrder', component: PricingOrder },
    

    // Products
    { path: '/Maktapti/ViewProducts', exact: true, name: 'ViewProducts', component: ViewProducts },
    { path: '/Maktapti/ViewProducts/EditProduct', exact: true, name: 'EditProduct', component: EditProduct },
    { path: '/Maktapti/ViewProducts/AddProduct', exact: true, name: 'AddProduct', component: AddProduct },

    // Reports
    { path: '/Maktapti/Reports', exact: true, name: 'CreateReport', component: CreateReport },
    { path: '/Maktapti/Reports/ShowReports', exact: true, name: 'Reports', component: Reports },

    // Certifications
    { path: '/Maktapti/Certifications', exact: true, name: 'ViewCertifications', component: ViewCertifications },
    { path: '/Maktapti/Certifications/EditCertificate', exact: true, name: 'EditBanner', component: EditCertificate },
    { path: '/Maktapti/Certifications/AddCertificate', exact: true, name: 'AddBanner', component: AddCertificate },

    // Shop
    { path: '/Maktapti/Shop', exact: true, name: 'Shop', component: Shop },

    // Services
    { path: '/Maktapti/Services', exact: true, name: 'Services', component: Services },

    // Levels
    { path: '/Maktapti/ViewLevels', exact: true, name: 'ViewLevels', component: ViewLevels },
    { path: '/Maktapti/Levels/EditLevel', exact: true, name: 'EditLevel', component: EditLevel },
    { path: '/Maktapti/Levels/AddLevel', exact: true, name: 'AddLevel', component: AddLevel },

    // Promo
    { path: '/Maktapti/PromoView', exact: true, name: 'PromoView', component: PromoView },
    { path: '/Maktapti/PromoView/AddPromo', exact: true, name: 'AddPromo', component: AddPromo },
    { path: '/Maktapti/PromoView/EditPromo', exact: true, name: 'EditPromo', component: EditPromo },

    // SocialLinks
    { path: '/Maktapti/SocialLinks', exact: true, name: 'SocialLinks', component: SocialLinks },

    //materials
    { path: '/Maktapti/ViewMaterials', exact: true, name: 'ViewMaterials', component: ViewMaterials },
    { path: '/Maktapti/ViewNotPricedMaterials', exact: true, name: 'ViewNotPricedMaterials', component: ViewNotPricedMaterials },
    { path: '/Maktapti/Editmaterialprice', exact: true, name: 'Editmaterialprice', component: Editmaterialprice },
    { path: '/Maktapti/AddMaterials', exact: true, name: 'AddMaterials', component: AddMaterials },
    
    //notification
    { path: '/Maktapti/ViewNotification', exact: true, name: 'ViewNotification', component: ViewNotification },
    { path: '/Maktapti/AddNotification', exact: true, name: 'AddNotification', component: AddNotification },
    
    
]

export default routes;